import { render, staticRenderFns } from "./PublicForgotPassword.vue?vue&type=template&id=37de2fb7&"
import script from "./PublicForgotPassword.vue?vue&type=script&lang=js&"
export * from "./PublicForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./PublicForgotPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports